<template>
  <component
    :is="facetComponent"
    :facet="facet"
    :is-dynamic="isDynamic"
    :scroll-to-selected="active"
    v-bind="facetOptions"
  />
</template>

<script setup>
import { computed } from 'vue';
import useFacetTypes from '../../composables/useFacetTypes';

const props = defineProps({
  facet: {
    type: Object,
    required: true,
  },
  active: {
    type: Boolean,
    default: () => false,
  },
  facetOptions: {
    type: Object,
    default: () => ({}),
  },
  isDynamic: {
    type: Boolean,
    default: () => false,
  },
});

const { getFacetTypeComponent } = useFacetTypes();

const facetComponent = computed(() => getFacetTypeComponent(props.facet));

</script>
